var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarousal3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2422,
    height: 1926,
    viewBox: "0 0 2422 1926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M625.709 1510.07L434.398 1536.94L249.557 221.021L512.961 184.017",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.57 110.044L1302.98 73.0396L1426.13 949.792",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.59 126.494C1042.58 112.126 1034.93 99.1466 1023.35 90.4124C1011.76 81.6794 997.179 77.905 982.81 79.9198C975.696 80.9215 968.454 80.5119 961.498 78.714C954.542 76.9161 948.008 73.7644 942.271 69.44C936.533 65.1169 931.704 59.7041 928.059 53.513C924.414 47.3231 922.024 40.4735 921.026 33.3586C919.679 23.7937 914.589 15.1552 906.875 9.34043C899.161 3.52698 889.454 1.01325 879.888 2.35177L636.81 36.4975C632.073 37.1611 627.513 38.7497 623.39 41.1754C619.267 43.601 615.664 46.8165 612.784 50.6356C609.904 54.4547 607.806 58.8033 606.608 63.4352C605.41 68.0658 605.137 72.8865 605.803 77.623C606.803 84.7393 606.391 91.9819 604.592 98.9386C602.793 105.895 599.64 112.43 595.316 118.168C590.99 123.906 585.577 128.737 579.386 132.384C573.195 136.029 566.345 138.421 559.229 139.42C552.115 140.419 545.267 142.81 539.077 146.456C532.887 150.101 527.476 154.931 523.151 160.669C518.828 166.406 515.677 172.938 513.877 179.893C512.08 186.849 511.667 194.09 512.668 201.204L521.842 266.522L1053.77 191.812L1044.59 126.494ZM780.806 179.32C771.669 180.606 762.357 179.153 754.045 175.146C745.734 171.138 738.798 164.757 734.114 156.806C729.43 148.857 727.208 139.697 727.73 130.485C728.253 121.272 731.495 112.422 737.047 105.053C742.6 97.683 750.213 92.126 758.924 89.084C767.636 86.0408 777.052 85.6503 785.986 87.9599C794.919 90.2707 802.967 95.1782 809.111 102.062C815.255 108.946 819.219 117.497 820.503 126.634C822.224 138.885 819.009 151.317 811.564 161.197C804.12 171.079 793.056 177.596 780.806 179.32Z",
    fill: "#A7ECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.77 191.812L1044.59 126.494C1042.58 112.126 1034.93 99.1466 1023.35 90.4124C1011.76 81.6794 997.179 77.905 982.81 79.9198C975.696 80.9202 968.455 80.5093 961.5 78.7102C954.544 76.911 948.011 73.7606 942.274 69.4362C936.537 65.1131 931.707 59.7016 928.062 53.5104C924.416 47.3206 922.025 40.4736 921.026 33.3586C919.679 23.7937 914.589 15.1552 906.875 9.34043C899.161 3.52698 889.454 1.01325 879.888 2.35177L636.81 36.4975C632.073 37.1623 627.514 38.7522 623.393 41.1792C619.271 43.6049 615.668 46.8191 612.788 50.6382C609.909 54.4572 607.81 58.8058 606.612 63.4365C605.413 68.0658 605.138 72.8865 605.803 77.623C607.819 91.9933 604.045 106.577 595.31 118.165C586.578 129.754 573.598 137.398 559.229 139.42C544.862 141.441 531.887 149.085 523.156 160.671C514.425 172.258 510.652 186.837 512.668 201.204L521.842 266.522L1053.77 191.812Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.81 888.841L1232.38 166.715L343.228 291.61L504.986 1443.27L625.708 1426.33",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.08 1090L1347.78 988.34",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 443.809L1140.74 351.299",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M501.49 581.309L1160.06 488.799",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M520.796 718.816L1179.36 626.306",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M540.115 856.303L1198.68 763.806",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M559.42 993.801L1163.9 908.901",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M820.503 126.635C821.786 135.773 820.332 145.085 816.323 153.396C812.312 161.706 805.928 168.641 797.978 173.324C790.027 178.006 780.865 180.225 771.654 179.7C762.441 179.176 753.592 175.931 746.223 170.377C738.855 164.821 733.3 157.207 730.26 148.495C727.22 139.782 726.832 130.365 729.145 121.432C731.457 112.5 736.367 104.453 743.252 98.3108C750.139 92.1694 758.692 88.2074 767.829 86.9263C773.896 86.0739 780.07 86.4248 786 87.9599C791.931 89.4949 797.5 92.1821 802.391 95.8698C807.283 99.5574 811.4 104.173 814.508 109.452C817.615 114.73 819.652 120.569 820.503 126.635Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2369.8 701.355C2320.34 637.364 2232.19 603.498 2154.22 624.693C2074.42 646.576 2011.18 716.743 1966.84 786.579C1922.51 716.731 1865.47 646.576 1785.64 624.693C1707.65 603.307 1619.52 637.261 1570 701.355C1498.9 793.444 1488.34 928.878 1632.92 1090H1810.59C1838.52 1090 1865.32 1101.1 1885.07 1120.85C1904.82 1140.61 1915.92 1167.4 1915.92 1195.33V1328.96C1934.55 1341.24 1953.18 1352.85 1971.63 1363.65C2084.44 1294.91 2188.21 1212.33 2280.51 1117.83C2451.75 944.931 2444.4 797.884 2369.8 701.355Z",
    fill: "#A7ECFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.01 1328.96C1934.64 1341.24 1953.21 1352.82 1971.72 1363.65C2084.53 1294.91 2188.3 1212.33 2280.6 1117.83C2451.75 944.931 2444.4 797.884 2369.8 701.355C2320.35 637.364 2232.19 603.498 2154.22 624.693C2074.43 646.576 2011.18 716.743 1966.84 786.579C1922.51 716.731 1865.47 646.576 1785.64 624.693C1707.65 603.307 1619.53 637.261 1570 701.355C1498.9 793.444 1488.34 928.878 1632.92 1090",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1546.09 961.325H1858.3L1905.89 847.008L1984.02 1248.47L2053.96 930.586H2405.41",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.17 1090C1150.76 1073.59 1153.63 1057.27 1159.63 1042C1165.62 1026.72 1174.61 1012.8 1186.07 1001.05C1197.53 989.31 1211.22 979.969 1226.35 973.602C1241.47 967.222 1257.71 963.943 1274.12 963.943C1290.53 963.943 1306.77 967.222 1321.89 973.602C1337.01 979.969 1350.71 989.31 1362.16 1001.05C1373.62 1012.8 1382.62 1026.72 1388.62 1042C1394.61 1057.27 1397.48 1073.59 1397.08 1090H1476.6C1477.29 1062.55 1472.46 1035.23 1462.43 1009.67C1452.4 984.116 1437.35 960.82 1418.18 941.164C1399 921.506 1376.09 905.885 1350.78 895.217C1325.48 884.551 1298.3 879.057 1270.84 879.057C1243.38 879.057 1216.2 884.551 1190.9 895.217C1165.59 905.885 1142.68 921.506 1123.51 941.164C1104.33 960.82 1089.28 984.116 1079.25 1009.67C1069.22 1035.23 1064.4 1062.55 1065.09 1090H1151.17Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1810.68 1090H731.043C672.869 1090 625.709 1137.16 625.709 1195.33V1818.52C625.709 1876.69 672.869 1923.85 731.043 1923.85H1810.68C1868.85 1923.85 1916.01 1876.69 1916.01 1818.52V1195.33C1916.01 1137.16 1868.85 1090 1810.68 1090Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1506.86 1437.7H1341.1V1278.72H1191.86V1437.7H1032.88V1586.91H1191.86V1752.7H1341.1V1586.91H1506.86V1437.7Z",
    fill: "#A7ECFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1506.86 1437.7H1341.1V1278.72H1191.86V1437.7H1032.88V1586.91H1191.86V1752.7H1341.1V1586.91H1506.86V1437.7Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M841.404 1456.03C889.676 1456.03 928.81 1416.9 928.81 1368.63C928.81 1320.36 889.676 1281.22 841.404 1281.22C793.13 1281.22 753.998 1320.36 753.998 1368.63C753.998 1416.9 793.13 1456.03 841.404 1456.03Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.791 1167.64C119.601 1130.18 114.768 1091.47 115.436 1052.65C115.587 990.879 130.039 929.973 157.659 874.715C150.326 874.504 143.116 872.761 136.498 869.597C129.878 866.432 123.994 861.916 119.226 856.34C85.061 916.177 67.0324 983.861 66.9099 1052.77C65.7398 1097.5 72.4694 1142.1 86.79 1184.49C91.5022 1177.76 98.0966 1172.57 105.748 1169.57C113.397 1166.57 121.761 1165.91 129.791 1167.64Z",
    fill: "#A7ECFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M129.791 1167.64C119.601 1130.18 114.768 1091.47 115.436 1052.65C115.587 990.879 130.039 929.973 157.659 874.715C150.326 874.504 143.116 872.761 136.498 869.597C129.878 866.432 123.994 861.916 119.226 856.34C85.061 916.177 67.0324 983.861 66.9099 1052.77C65.7398 1097.5 72.4694 1142.1 86.79 1184.49C91.5022 1177.76 98.0966 1172.57 105.748 1169.57C113.397 1166.57 121.761 1165.91 129.791 1167.64Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M500.507 848.391C496.854 854.712 491.931 860.207 486.048 864.53C480.163 868.852 473.447 871.906 466.323 873.502C494.357 929.07 509.033 990.42 509.184 1052.65C509.848 1091.48 505.01 1130.19 494.816 1167.66C502.836 1165.92 511.19 1166.6 518.831 1169.58C526.471 1172.58 533.058 1177.76 537.766 1184.47C552.091 1142.09 558.82 1097.5 557.647 1052.77C557.68 980.697 537.914 909.996 500.507 848.391Z",
    fill: "#A7ECFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M500.507 848.391C496.854 854.712 491.931 860.207 486.048 864.53C480.163 868.852 473.447 871.906 466.323 873.502C494.357 929.07 509.033 990.42 509.184 1052.65C509.848 1091.48 505.01 1130.19 494.816 1167.66C502.836 1165.92 511.19 1166.6 518.831 1169.58C526.471 1172.58 533.058 1177.76 537.766 1184.47C552.091 1142.09 558.82 1097.5 557.647 1052.77C557.68 980.697 537.914 909.996 500.507 848.391Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M159.254 874.763C188.387 874.763 212.004 851.147 212.004 822.013C212.004 792.881 188.387 769.264 159.254 769.264C130.122 769.264 106.504 792.881 106.504 822.013C106.504 851.147 130.122 874.763 159.254 874.763Z",
    fill: "#6095B3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M159.254 874.763C188.387 874.763 212.004 851.147 212.004 822.013C212.004 792.881 188.387 769.264 159.254 769.264C130.122 769.264 106.504 792.881 106.504 822.013C106.504 851.147 130.122 874.763 159.254 874.763Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M454.814 874.763C483.946 874.763 507.564 851.147 507.564 822.013C507.564 792.881 483.946 769.264 454.814 769.264C425.681 769.264 402.064 792.881 402.064 822.013C402.064 851.147 425.681 874.763 454.814 874.763Z",
    fill: "#6095B3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M454.814 874.763C483.946 874.763 507.564 851.147 507.564 822.013C507.564 792.881 483.946 769.264 454.814 769.264C425.681 769.264 402.064 792.881 402.064 822.013C402.064 851.147 425.681 874.763 454.814 874.763Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M309.86 1376.98C154.967 1376.98 86.0755 1232.07 83.23 1226.03C78.5599 1216 78.0648 1204.53 81.8545 1194.13C85.6429 1183.75 93.4061 1175.29 103.435 1170.62C113.465 1165.95 124.937 1165.45 135.332 1169.24C145.726 1173.03 154.188 1180.79 158.859 1190.82C161.041 1195.49 209.082 1293.56 309.86 1293.56C411.826 1293.56 464.256 1193.87 466.375 1189.63C468.849 1184.74 472.262 1180.39 476.418 1176.82C480.575 1173.25 485.395 1170.53 490.602 1168.82C495.809 1167.11 501.301 1166.44 506.765 1166.87C512.23 1167.27 517.559 1168.77 522.448 1171.24C527.338 1173.7 531.693 1177.12 535.263 1181.28C538.833 1185.43 541.55 1190.25 543.259 1195.46C544.966 1200.67 545.632 1206.17 545.217 1211.63C544.803 1217.09 543.316 1222.42 540.842 1227.31C537.754 1233.34 463.823 1376.98 309.86 1376.98Z",
    fill: "#6095B3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M309.86 1376.98C154.967 1376.98 86.0755 1232.07 83.23 1226.03C78.5599 1216 78.0648 1204.53 81.8545 1194.13C85.6429 1183.75 93.4061 1175.29 103.435 1170.62C113.465 1165.95 124.937 1165.45 135.332 1169.24C145.726 1173.03 154.188 1180.79 158.859 1190.82C161.041 1195.49 209.082 1293.56 309.86 1293.56C411.826 1293.56 464.256 1193.87 466.375 1189.63C468.849 1184.74 472.262 1180.39 476.418 1176.82C480.575 1173.25 485.395 1170.53 490.602 1168.82C495.809 1167.11 501.301 1166.44 506.765 1166.87C512.23 1167.27 517.559 1168.77 522.448 1171.24C527.338 1173.7 531.693 1177.12 535.263 1181.28C538.833 1185.43 541.55 1190.25 543.259 1195.46C544.966 1200.67 545.632 1206.17 545.217 1211.63C544.803 1217.09 543.316 1222.42 540.842 1227.31C537.754 1233.34 463.823 1376.98 309.86 1376.98Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M841.403 1400.97C859.267 1400.97 873.75 1386.49 873.75 1368.63C873.75 1350.76 859.267 1336.28 841.403 1336.28C823.539 1336.28 809.057 1350.76 809.057 1368.63C809.057 1386.49 823.539 1400.97 841.403 1400.97Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M312.042 1375.58V1758.79C311.876 1775.06 314.937 1791.19 321.047 1806.27C327.156 1821.34 336.194 1835.06 347.636 1846.62C359.079 1858.18 372.701 1867.35 387.711 1873.62C402.724 1879.88 418.828 1883.1 435.093 1883.1C451.358 1883.1 467.463 1879.88 482.475 1873.62C497.486 1867.35 511.107 1858.18 522.55 1846.62C533.992 1835.06 543.03 1821.34 549.139 1806.27C555.249 1791.19 558.31 1775.06 558.144 1758.79V1703.74C558.144 1675.86 569.221 1649.12 588.939 1629.4C608.657 1609.68 635.401 1598.6 663.287 1598.6H735.725C749.603 1598.6 763.344 1595.86 776.163 1590.54C788.981 1585.21 800.628 1577.43 810.436 1567.62C820.245 1557.79 828.023 1546.14 833.328 1533.32C838.632 1520.5 841.359 1506.75 841.352 1492.87V1455.98",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2676 372.582V439.291",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2676 518.98V585.676",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2 532.403L59.7645 499.049",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M128.771 459.207L186.548 425.852",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M186.548 532.403L128.771 499.049",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7645 459.207L2 425.852",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M120.719 1859.31C144.144 1859.31 163.133 1840.33 163.133 1816.9C163.133 1793.48 144.144 1774.48 120.719 1774.48C97.2941 1774.48 78.3047 1793.48 78.3047 1816.9C78.3047 1840.33 97.2941 1859.31 120.719 1859.31Z",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1675.03 421.323V511.524",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1720.12 466.419H1629.92",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2045.92 1534.8V1684.67",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2120.86 1609.73H1970.98",
    stroke: "#43677B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousal3);
export default __webpack_public_path__ + "static/media/Carousal_3.2f2cc1d475d647465aa245ce872b26af.svg";
export { ForwardRef as ReactComponent };